import type { Option } from '@lib/components/Select/types'
import type { Ga4Property } from '@store/reducers/ga4'

// Аккаунт — вторая строка смысла: у одного Google-аккаунта пропертей бывают
// десятки, и одинаковые имена сайтов различаются только аккаунтом.
export const buildPropertyOptions = (properties: Ga4Property[]): Option[] =>
  properties.map((property) => ({
    value: property.propertyId,
    label: property.displayName,
    rightText: property.account,
  }))

export const formatUpdatedAt = (updatedAtSeconds: number | null): string => {
  if (updatedAtSeconds === null) {
    return 'just now'
  }

  const hours = Math.floor((Date.now() / 1000 - updatedAtSeconds) / 3600)

  if (hours < 1) {
    return 'less than an hour ago'
  }

  if (hours === 1) {
    return 'an hour ago'
  }

  return `${hours} hours ago`
}
